import React from "react";
import Chart from "react-apexcharts";
import { getEventTypeStatusData } from "../../../../services/event/dashboard/dashboardServices";
import { useState, useEffect } from "react";

const EventTypeChart = (props) => {
  const { startMonth, endMonth, subDomain } = props;

  const [chartData, setChartData] = useState({
    options: {},
    series: [],
  });
  const { series, options } = chartData;
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await getEventTypeStatusData(
          {
            sub_domain: subDomain,
            fromDate:startMonth,
            toDate: endMonth,
          }

        );
  
        console.log("Response eventtype :", response); 
  
        // Ensure response contains the expected structure
        if (response && Array.isArray(response.series) && response.series.length > 0) {
          const total = response.series.reduce((sum, value) => sum + value, 0);
            setChartData((prevData) => ({
              ...prevData,
            series: response.series.map((value) => (value)),
              options: {
                ...prevData.options,
                ...response.options,
                title: {
                  text: `Total: ${total}`,
                  style: {
                    fontSize: "16px",
                    fontWeight: 800,
                    color: "#333",
                  },
                },
              },
            }));
          } else {
            console.error("Invalid or missing data in response:", response);
          }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };
  
    fetchData();
  }, [subDomain, startMonth, endMonth]);

  return (
  <>
      <Chart options={options} series={series} type="polarArea" height={props.height} />
  </>
  )
}
export default EventTypeChart;
